module.exports = __webpack_public_path__ + "img/facility_3.713a349f.jpg";